export const ROUTES = {}

export const DEFAULT_PAGE_SIZE = 10

export const API_URL = 'http://localhost:3000'
